import * as actions from "./useKai.actions"

import type { Action, State } from "./useKai.types"

export const getInitialState = (): State => ({
  open: false,
  isDirty: true,
  drawers: {}
})

export const reducer = (state: State, action: Action): State => {
  switch (action.type) {
    case actions.TOGGLE_KAI:
      return { ...state, open: !state.open }
    case actions.UPDATE_DRAWER_STATE:
      return {
        ...state,
        isDirty: true,
        drawers: {
          ...state.drawers,
          [action.payload.drawerId]: {
            ...state.drawers[action.payload.drawerId],
            ...action.payload,
            open: true
          }
        }
      }
    case actions.CLOSE_DRAWER: {
      const { [action.payload.drawerId]: _, ...rest } = state.drawers

      return {
        ...state,
        isDirty: true,
        drawers: rest
      }
    }

    case actions.SET_DIRTY_CONTEXT:
      return {
        ...state,
        isDirty: action.payload
      }

    default:
      return state
  }
}
